import { render, staticRenderFns } from "./LeavesRegularizationTabs.vue?vue&type=template&id=03bed2ee&scoped=true&"
import script from "./LeavesRegularizationTabs.vue?vue&type=script&lang=js&"
export * from "./LeavesRegularizationTabs.vue?vue&type=script&lang=js&"
import style0 from "./LeavesRegularizationTabs.vue?vue&type=style&index=0&id=03bed2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bed2ee",
  null
  
)

export default component.exports